import React from "react"
import { useSelector } from "react-redux"
import { Link, useParams } from "react-router-dom"
import { Container } from "reactstrap"
import FeedbackAnalysis from "./FeedbackAnalysis"
import FeedbackSetup from "./FeedbackSetup"
import useFeedbackCatalog from "./useFeedbackCatalog"
import "./tournamentFeedback.scss"

// CP „Tournament feedback” (sportya-api ADR 0005, docs/design/tournament-feedback): SuperAdmin only, next to System
// Settings, with the Analysis tab (the default) and the Setup tab (the catalog of themes and reasons). It works while the
// feedback is off in the environment, so the catalog is prepared and checked before it is turned on.
const TABS = [["analysis", "Analysis"], ["setup", "Setup"]]
const FEATURE_TEXT = {
  off: "Tournament feedback is off in this environment. Players see nothing yet; prepare and check the themes and reasons before it is turned on.",
  on: "Tournament feedback is on in this environment. A change reaches the feedback forms players open after it.",
}

export default function TournamentFeedback() {
  const { tab } = useParams()
  const current = tab === "setup" ? "setup" : "analysis"
  const user = useSelector(state => state.session?.userDetails)
  const allowed = user?.role === "superAdmin" && user.status === "activated"
  const { read, retry, reload } = useFeedbackCatalog(allowed)
  if (!allowed) return <div className="page-content"><Container fluid><p role="alert">Active SuperAdmin access is required.</p></Container></div>
  const enabled = read.data?.feature.enabled
  return <div className="page-content tournament-feedback"><Container fluid>
    <div className="tournament-feedback__heading"><h4>Tournament feedback</h4><span className="text-muted">SuperAdmin · Dates and times: Europe/Bucharest</span></div>
    {/* The feature's state: off on both tabs, on only on Setup, where a change reaches the players. */}
    {read.data && (!enabled || current === "setup") && <div className={"alert small " + (enabled ? "alert-success" : "alert-info")}>
      {enabled ? FEATURE_TEXT.on : FEATURE_TEXT.off}
    </div>}
    <ul className="nav nav-tabs nav-tabs-custom mb-4" role="tablist">
      {TABS.map(([key, label]) => <li className="nav-item" key={key}>
        <Link role="tab" aria-selected={current === key} className={"nav-link" + (current === key ? " active" : "")} to={`/tournament-feedback/${key}`}>{label}</Link>
      </li>)}
    </ul>
    {current === "setup" ? <FeedbackSetup read={read} onRetry={retry} onChanged={reload} actorId={user.id || user._id} /> : <FeedbackAnalysis />}
  </Container></div>
}
